import createBrowserHistory from "history/createBrowserHistory";
import createMemoryHistory from "history/createMemoryHistory";

let _history = null;
let _historyForReplace = null;

function _determineHistorySupport() {
  return !!(typeof "window" !== "undefined" && window && window.history && window.history.pushState);
}

export function overrideHistorySingleton(opts = {}) {
  _history = createBrowserHistory({
    forceRefresh: !_determineHistorySupport(),
    ...opts,
  });
}

export function overrideHistoryForReplaceSingleton(opts = {}) {
  if (_determineHistorySupport()) {
    _historyForReplace = createBrowserHistory(opts);
  } else {
    _historyForReplace = createMemoryHistory(opts);
  }
}

// 主 push 用这个
export function getHistory() {
  if (!_history) overrideHistorySingleton();
  return _history;
}

// 主 replace 用这个
export function getHistoryForReplacing() {
  if (!_historyForReplace) overrideHistoryForReplaceSingleton();
  return _historyForReplace;
}
